import { BuildingType } from '../buildings';
import imgOutside from '../../assets/buildings/factory/outside.png';
import imgHeating from '../../assets/buildings/factory/heating.png';
import imgProduction from '../../assets/buildings/factory/production.png';
import imgProductionWater from '../../assets/buildings/factory/water.png';
import imgProcesses from '../../assets/buildings/factory/processes.png';
import imgFireProtection from '../../assets/buildings/factory/fire-protection.png';
import imgSprinklerCenter from '../../assets/buildings/factory/sprinkler-center.png';
import imgWasteWater from '../../assets/buildings/factory/waste-water.webp';
import { BuildingArea, SubBuilding } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { activeLanguage } from '../../activeLanguage';
import { isNoBoolean } from '../../components/utils/isNoBoolean';

const factoryConfig: BuildingArea = {
    sectorPosition: 'bottom',
    techSectors: [
        activeLanguage.locale.language === 'de' && {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            buildings: [],
            products: [
                {
                        position: { x: 190, y: 810 },
                    type: ProductType.AMAREX,
                },
                {
                        position: { x: 1160, y: 620 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
                {
                        position: { x: 1430, y: 630 },
                    type: ProductType.AMA_DRAINER_4_5,
                },
                {
                        position: { x: 1520, y: 500 },
                    type: ProductType.LEVELCONTROL_BASIC_2,
                },
                {
                        position: { x: 1655, y: 520 },
                    type: ProductType.COMPACTA,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            buildings: [
                {
                        coordinates: { x: 424, y: 743 },
                    building: BuildingType.FACTORY_SPRINKLER_CENTER,
                    link: `${BuildingType.FACTORY_SPRINKLER_CENTER}/${TechSector.FIRE_PROTECTION}`,
                    showSector: false,
                },
            ],
            products: [],
        },
        {
            type: TechSector.HEATING,
            img: imgOutside,
            buildings: [
                {
                        coordinates: { x: 459, y: 273 },
                    building: BuildingType.FACTORY_PRODUCTION,
                    link: `${BuildingType.FACTORY_PRODUCTION}/${TechSector.HEATING}`,
                    showSector: false,
                },
                {
                        coordinates: { x: 1145, y: 240},
                    building: BuildingType.FACTORY_PROCESSES,
                    link: `${BuildingType.FACTORY_PROCESSES}/${TechSector.HEATING}`,
                    showSector: false,
                },
                {
                        coordinates: { x: 1266, y: 653 },
                    building: BuildingType.FACTORY_HEATING,
                    link: `${BuildingType.FACTORY_HEATING}/${TechSector.HEATING}`,
                    showSector: false,
                },
            ],
        },
        activeLanguage.locale.language === 'de' && {
            type: TechSector.WATER,
            img: imgOutside,
            buildings: [
                {
                        coordinates: { x: 459, y: 273 },
                    building: BuildingType.FACTORY_PRODUCTION,
                    link: `${BuildingType.FACTORY_PRODUCTION}/${TechSector.WATER}`,
                    showSector: false,
                },
            ],
        },
    ].filter(isNoBoolean),
    img: imgOutside,
};

export const factoryHeatingConfig: SubBuilding = {
    parentBuilding: BuildingType.FACTORY,
    img: imgHeating,
    techSectors: [
        {
            type: TechSector.HEATING,
        },
    ],
    products: [
        {
            position: { x: 409, y: 653 },
            type: ProductType.ETALINE,
        },
        {
            position: { x: 468, y: 523 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
        {
            position: { x: 594, y: 603 },
            type: ProductType.BOA_H,
        },
        {
            position: { x: 866, y: 521 },
            type: ProductType.BOAX_MAT,
        },
        {
            position: { x: 894, y: 719 },
            type: ProductType.SISTO_RSK,
        },
        {
            position: { x: 1118, y: 579 },
            type: ProductType.BOA_CONTROL_IMS,
        },
        {
            position: { x: 1550, y: 783 },
            type: ProductType.ETANORM,
        },
        {
            position: { x: 1550, y: 703 },
            type: ProductType.SERIE_2000,
        },
        {
            position: { x: 1624, y: 843 },
            type: ProductType.HPK,
        },
    ],
};

export const factoryProcessesConfig: SubBuilding = {
    parentBuilding: BuildingType.FACTORY,
    img: imgProcesses,
    techSectors: [
        {
            type: TechSector.HEATING,
        }
    ],
    products: [
        {
                position: {x: 914, y: 428},
            type: ProductType.SISTO_RSK
        },
        {
                position: {x: 1114, y: 593},
            type: ProductType.MEGA_CPK
        },
        {
                position: {x: 1149, y: 413},
            type: ProductType.ECOLINE_GT_40
        },
    ]
}

export const factoryProductionConfig: SubBuilding = {
    parentBuilding: BuildingType.FACTORY,
    img: imgProduction,
    techSectors: [
        {
            type: TechSector.HEATING,
            products: [
                {
                        position: {x: 389, y: 483},
                    type: ProductType.MOVITEC_VCI
                },
                {
                        position: {x: 1114, y: 525},
                    type: ProductType.MOVITEC
                },
            ],
        },
        activeLanguage.locale.language === 'de' && {
            type: TechSector.WATER,
            img: imgProductionWater,
            products: [
                {
                        position: { x: 1519, y: 558 },
                    type: ProductType.ETANORM,
                },
                {
                        position: { x: 1684, y: 537 },
                    type: ProductType.BOA_COMPACT_EKB,
                },
            ],
        },
    ].filter(isNoBoolean),
    products: [],
};

export const factorySprinklerCenterConfig: SubBuilding = {
    parentBuilding: BuildingType.FACTORY,
    img: imgSprinklerCenter,
    techSectors: [
        {
            type: TechSector.FIRE_PROTECTION,
        }
    ],
    products: [
        {
            position: {x: 1184, y: 563},
            type: ProductType.MOVITEC
        },
        {
            position: {x: 1334, y: 603},
            type: ProductType.HYADUO_2_D_FL_COMPACT
        },
    ]
}

export default factoryConfig;
